export default "__VITE_ASSET__DwPjmR$j__"